// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"80a8b327","528":"e6a5e2d7","747":"2675cda0"}[chunkId] + ".chunk.css";
};